import { render, staticRenderFns } from "./ClassificationPopin.vue?vue&type=template&id=71b20f72"
import script from "./ClassificationPopin.vue?vue&type=script&lang=js"
export * from "./ClassificationPopin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71b20f72')) {
      api.createRecord('71b20f72', component.options)
    } else {
      api.reload('71b20f72', component.options)
    }
    module.hot.accept("./ClassificationPopin.vue?vue&type=template&id=71b20f72", function () {
      api.rerender('71b20f72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/appellation/ClassificationPopin.vue"
export default component.exports